"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConverterToNextProperty = void 0;

var Stream_1 = require("../../stream/Stream");

var ConverterToNext_1 = require("../arbitrary/definition/ConverterToNext");

var identifier = '__ConverterToNextProperty__';

var ConverterToNextProperty = /*#__PURE__*/function () {
  function ConverterToNextProperty(property) {
    _classCallCheck(this, ConverterToNextProperty);

    this.property = property;
    this[_a] = true;
  }

  _createClass(ConverterToNextProperty, [{
    key: "isAsync",
    value: function isAsync() {
      return this.property.isAsync();
    }
  }, {
    key: "generate",
    value: function generate(mrng, runId) {
      var shrinkable = this.property.generate(mrng, runId);
      return (0, ConverterToNext_1.fromShrinkableToNextValue)(shrinkable);
    }
  }, {
    key: "shrink",
    value: function shrink(value) {
      if (this.isSafeContext(value.context)) {
        return value.context.shrink().map(ConverterToNext_1.fromShrinkableToNextValue);
      }

      return Stream_1.Stream.nil();
    }
  }, {
    key: "isSafeContext",
    value: function isSafeContext(context) {
      return context != null && typeof context === 'object' && 'value' in context && 'shrink' in context;
    }
  }, {
    key: "run",
    value: function run(v) {
      return this.property.run(v);
    }
  }], [{
    key: "isConverterToNext",
    value: function isConverterToNext(property) {
      return identifier in property;
    }
  }]);

  return ConverterToNextProperty;
}();

exports.ConverterToNextProperty = ConverterToNextProperty;
_a = identifier;